import Link from "next/link";

interface PricingTier {
  name: string;
  price: string;
  priceSuffix?: string;
  sub: string;
  features: string[];
  featured?: boolean;
  cta?: { label: string; href: string };
}

interface PricingTiersProps {
  tiers: PricingTier[];
  layout: "grid" | "rows";
  /** Optional headline rendered inside the blue price card, above the tiers. */
  heading?: string;
}

export default function PricingTiers({ tiers, layout, heading }: PricingTiersProps) {
  if (!Array.isArray(tiers) || tiers.length === 0) {
    throw new Error("PricingTiers: `tiers` array is empty or invalid.");
  }

  return (
    <div className="price-card">
      {heading ? <h3 className="price-card-heading">{heading}</h3> : null}
      <div className={layout === "rows" ? "price-grid price-grid-rows" : "price-grid"}>
        {tiers.map((tier) => (
          <div className={`price-tier ${tier.featured ? "feature" : ""}`} key={tier.name}>
            <h3 className="price-tier-title">{tier.name}</h3>
            <div className="price-tier-value v">
              {tier.price}
              {tier.priceSuffix ? (
                <>
                  {" "}
                  <em className="price-tier-suffix">{tier.priceSuffix}</em>
                </>
              ) : null}
            </div>
            <p className="price-tier-sub sub">{tier.sub}</p>
            <ul>
              {tier.features.map((feature) => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>
            {tier.cta ? (
              <div className="price-tier-cta-wrap">
                <Link
                  href={tier.cta.href}
                  className={`btn ${tier.featured ? "btn-primary" : "btn-ghost"} price-tier-cta`}
                >
                  {tier.cta.label}
                </Link>
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}
